__webpack_require__.p = "/karedb/";